import { useQuery } from '@tanstack/react-query';
import { useApi } from '@iptv/ui';

export const qk = {
  overview: ['merchant', 'overview'] as const,
  usage: ['merchant', 'usage'] as const,
  announcements: ['merchant', 'announcements'] as const,
  branding: ['merchant', 'branding'] as const,
  featured: ['merchant', 'featured'] as const,
  settings: ['merchant', 'settings'] as const,
  hosts: ['merchant', 'hosts'] as const,
  hostUsage: ['merchant', 'hosts', 'usage'] as const,
  hostMonitor: ['merchant', 'hosts', 'monitor'] as const,
  hostCheckLink: ['merchant', 'hosts', 'check-link'] as const,
  hostHealth: (id: string) => ['merchant', 'hosts', id, 'health'] as const,
  devices: (q: object) => ['merchant', 'devices', q] as const,
  users: ['merchant', 'users'] as const,
  audit: (q: object) => ['merchant', 'audit', q] as const,
};

export function useOverview() {
  const api = useApi();
  return useQuery({ queryKey: qk.overview, queryFn: () => api.merchant.overview() });
}
